import React, { useState, useEffect, createContext } from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom"; // Changed to HashRouter
import MapComponent from "./components/MapComponent";
import TopMenu from "./components/TopMenu";
import ContentPage1 from "./components/ContentPage1";
import ContentPage2 from "./components/ContentPage2";
import WindowManager from "./components/Window";
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import { AuthProvider } from './context/AuthContext';
import { TRAFFIC_URL } from './data/config';

export const TrafficContext = createContext();

const App = () => {
  const [selectedContent, setSelectedContent] = useState("Content 1");
  const [traffic, setTraffic] = useState([]);
  const [openWindows, setOpenWindows] = useState([]);
  const [windowSize, setWindowSize] = useState(2);
  const [mapWidth, setMapWidth] = useState(50); // Default width of MapComponent in %

  useEffect(() => {
    const fetchTraffic = async () => {
      try {
        const response = await fetch(TRAFFIC_URL);
        const data = await response.json();
        const filteredTraffic = data.filter(
          (pilot) =>
            pilot.flight_plan &&
            (pilot.flight_plan.departure.startsWith("EF") || 
             pilot.flight_plan.arrival.startsWith("EF"))
        );
        setTraffic(filteredTraffic);
      } catch (error) {
        console.error("Error fetching traffic data:", error);
      }
    };

    fetchTraffic();
    const interval = setInterval(fetchTraffic, 10000);
    return () => clearInterval(interval);
  }, []);

  // Handle resizing
  const handleMouseDown = (e) => {
    e.preventDefault();

    const startX = e.clientX;
    const startWidth = mapWidth;

    const handleMouseMove = (e) => {
      const delta = ((e.clientX - startX) / window.innerWidth) * 100;
      const newWidth = Math.min(Math.max(startWidth + delta, 30), 70); // Constrain width between 30% and 70%
      setMapWidth(newWidth);
    };

    const handleMouseUp = () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <AuthProvider>
      <TrafficContext.Provider value={traffic}>
        <Router>
          <div className="min-h-screen flex flex-col">
            <Routes>
              <Route path="/login" element={<Login />} />
              
              <Route path="/" element={
                <ProtectedRoute>
                  <>
                    <TopMenu setSelectedContent={setSelectedContent} openWindows={openWindows} setOpenWindows={setOpenWindows} setWindowSize={setWindowSize}/>

                    {/* MapComponent */}
                    <div style={{ 
                      position: 'fixed', 
                      width: `${mapWidth}%`, 
                      height: '100%'
                    }}>
                      <MapComponent openWindows={openWindows} setOpenWindows={setOpenWindows} setWindowSize={setWindowSize}/>
                    </div>

                    {/* Resizable Handle */}
                    <div 
                      style={{
                        position: 'fixed',
                        left: `${mapWidth}%`,
                        top: '0',
                        height: '100vh',
                        width: '5px',
                        cursor: 'ew-resize',
                        backgroundColor: '#4A5568', // Gray handle
                        zIndex: 10
                      }} 
                      onMouseDown={handleMouseDown}
                    />

                    {/* Content Pages */}
                    <div style={{ 
                      position: 'fixed', 
                      right: '0', 
                      top: '0', 
                      marginTop: '28px', 
                      width: `${100 - mapWidth}%`, 
                      bottom: '50%' 
                    }}>
                      <ContentPage1 />
                    </div>
                    <div style={{ 
                      position: 'fixed', 
                      right: '0', 
                      bottom: '0', 
                      width: `${100 - mapWidth}%`, 
                      top: '50%' 
                    }}>
                      <ContentPage2 />
                    </div>

                    <WindowManager openWindows={openWindows} setOpenWindows={setOpenWindows} size={windowSize}/>
                  </>
                </ProtectedRoute>
              } />
              
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </div>
        </Router>
      </TrafficContext.Provider>
    </AuthProvider>
  );
};

export default App;
